if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(swymRenderWishlist);

var WishlistedProducts = [];

function swymRenderWishlist(swat) {
  swat.fetch(function (products) {
    WishlistedProducts = JSON.parse(JSON.stringify(products));

    var container = document.getElementById("wishlist-items-container");
    if (!container) return;

    if (products.length === 0) {
      container.innerHTML = '<p style="text-align:center; padding: 20px 0;">Your wishlist is empty.</p>';
      countWishlist(swat);
      return;
    }

    container.innerHTML = "";
    container.style.opacity = "0.5";
    container.style.pointerEvents = "none";

    var fetchPromises = products.map(function (p) {
      var url = p.du.split('?')[0] + "?section_id=wishlist-product-card";
      
      return fetch(url)
        .then(function(res) {
          return res.text();
        })
        .then(function(html) {
          return { product: p, html: html };
        })
        .catch(function(err) {
          console.error("Wishlist item fetch error", err);
          return null;
        });
    });

    Promise.all(fetchPromises).then(function (results) {
      var gridHtml = '<div class="swym-wishlist-grid">';
      
      results.forEach(function (r) {
        if (!r) return;
        var p = r.product;

        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = r.html;
        var sectionInner = tempDiv.querySelector('.shopify-section') 
          ? tempDiv.querySelector('.shopify-section').innerHTML 
          : tempDiv.innerHTML;

        gridHtml += `
          <div class="product-item col_slide" style="position:relative;">
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="${p.epi}" data-product-id="${p.empi}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button" style="position:absolute; top:10px; right:15px; z-index:9; background:transparent; border:none; padding:5px; cursor:pointer;" title="Remove from wishlist">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M4.05566 2.0249H4.06543C4.88093 2.02062 5.65889 2.36687 6.20215 2.9751L6.50098 3.30908L6.79883 2.9751C7.34201 2.36695 8.12017 2.02071 8.93555 2.0249H8.94531C9.62305 2.01235 10.278 2.27266 10.7617 2.74756C11.2453 3.22245 11.5177 3.87249 11.5176 4.55029C11.5175 5.83814 10.7484 7.01281 9.65918 8.11963C9.11975 8.66779 8.51701 9.18403 7.91992 9.67627C7.43117 10.0792 6.93917 10.4736 6.50195 10.8462C6.06476 10.4704 5.57245 10.0754 5.08301 9.67139C4.48572 9.1783 3.88263 8.66205 3.34277 8.11475C2.25305 7.00992 1.48449 5.83872 1.48438 4.55029C1.48426 3.87244 1.75654 3.22246 2.24023 2.74756C2.72388 2.27282 3.37806 2.01237 4.05566 2.0249Z" fill="#1A1D2C" stroke="#1A1D2C" stroke-width="0.8"/></svg>
            </button>
            ${sectionInner}
          </div>
        `;
      });
      
      gridHtml += '</div>';
      container.innerHTML = gridHtml;
      
      container.style.opacity = "1";
      container.style.pointerEvents = "auto";

      if (window.innerWidth <= 991) {
        if (typeof Swiper !== 'undefined') {
          try {
            new Swiper('#wishlist-items-container', { slidesPerView: 'auto' });
          } catch(e) { }
        }
      }

      attachClickListeners();
      countWishlist();

      if (typeof initProductSliders === 'function') setTimeout(initProductSliders, 100);
      if (typeof quickAddButton === 'function') quickAddButton();

      container.querySelectorAll('.shop-look-button').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault(); 
          e.stopImmediatePropagation();
          var url = btn.getAttribute('data-url');
          var modal = btn.getAttribute('data-modal');
          fetch(url)
            .then(function(res) { return res.text(); })
            .then(function(response) {
              var doc = new DOMParser().parseFromString(response, 'text/html');
              var source = doc.getElementById('section-shop-look');
              document.body.classList.add('open-shop-look');
              var popupModal = document.getElementById(modal);
              var popup = popupModal ? popupModal.querySelector('.shop-look-popup') : null;
              if (popup && source) popup.innerHTML = source.innerHTML;
              if (typeof addToCart === 'function') addToCart();
            }).catch(function(err) { console.error(err); });
        });
      });
    });
  });
}

function attachClickListeners() {
  document.querySelectorAll("#swym-remove-productBtn").forEach(function(btn) {
    btn.addEventListener("click", onRemoveBtnClick);
  });
}

function onRemoveBtnClick(e) {
  e.preventDefault();

  var btn = e.currentTarget;
  var epi = +btn.getAttribute("data-variant-id");
  var empi = +btn.getAttribute("data-product-id");

  btn.closest(".col_slide").style.opacity = "0.5";

  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          swymRenderWishlist(window._swat);
        });
      }
    });
  });
}

function countWishlist() {
  if (!window._swat) return;
  window._swat.fetch(function (r) {
    var count = r.length;
    document.querySelectorAll(".favourite-count").forEach(function (el) {
      el.innerHTML = count;
    });
  });
}